import { Form as AntForm, FormProps } from 'antd'

type ExtraFormStuff = {
  Item: typeof AntForm.Item
  List: typeof AntForm.List
  useForm: typeof AntForm.useForm
  useFormInstance: typeof AntForm.useFormInstance
  useWatch: typeof AntForm.useWatch
}

type Props = Omit<FormProps, 'children'> & {
  children?: React.ReactNode
}

export const Form: React.FC<Props> & ExtraFormStuff = ({
  children,
  ...formProps
}) => {
  return (
    <AntForm
      colon={false}
      layout="vertical"
      scrollToFirstError={{ block: 'center', scrollMode: 'always' }}
      {...formProps}
    >
      {children}
    </AntForm>
  )
}

export const HorizontalForm: React.FC<Props> = ({ children, ...formProps }) => {
  return (
    <AntForm
      layout="horizontal"
      labelCol={{ span: 6 }}
      labelAlign="left"
      colon={false}
      scrollToFirstError={{ block: 'center', scrollMode: 'always' }}
      {...formProps}
    >
      {children}
    </AntForm>
  )
}

Form.Item = AntForm.Item
Form.List = AntForm.List
Form.useForm = AntForm.useForm
Form.useFormInstance = AntForm.useFormInstance
Form.useWatch = AntForm.useWatch
